module.exports = __webpack_public_path__ + "img/gamble_feature.f97ea32a.png";